import { PageHeader } from '@/components/campaign/page-header';
import { TabBar } from '@/components/glitch-ui/tab-bar';
import { CampaignTabValue, SettingsTabValue, Tab, TasksTabValue } from '@/lib/types';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useState } from 'react';
import { useUserProfile } from '@/contexts/user.context';
import { UserRole } from '@/lib/types';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/_layout/tasks/_layout')({
  component: TasksLayout,
});

function TasksLayout() {
  const [currentTab, setCurrentTab] = useState<CampaignTabValue | SettingsTabValue | TasksTabValue>('new');
  const { user } = useUserProfile();
  const isAdmin = user && user.role === UserRole.ADMIN;
  const { t } = useTranslation('tasks');

  const settingTabs: Tab[] = [
    { id: 'new', name: t('taskPage.tabs.new'), href: '/tasks/new' },
  ];

  return (
    <div>
      <PageHeader title="Automations" data-admin={isAdmin} />
      <TabBar tabs={settingTabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
      <Outlet />
    </div>
  );
}
